import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from "lodash";
import { Request } from "./request";
import { URLS } from "../constants/url.constants";
import { map } from "rxjs/operators";
import { HttpClient, HttpHeaders, HttpRequest } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class CommonService {
  protected environment: any;
  constructor(
    @Inject('AppEnvironment') environmentConfig,
    private request: Request,
    private http: HttpClient,
  ) {
    this.environment = environmentConfig;
  }


  getEntity() {
    let get_entity = localStorage.getItem('currentApp' + this.environment.role) + '--' + localStorage.getItem('currentAppType' + this.environment.role);
    return encodeURI(get_entity);
  }

  getAllEntities(): Observable<any> {
    return this.request.getApi('get-all-entites').pipe(map(response => {
      return response.body.data.entities;
    }));
  }

  savePasswords(values): Observable<any> {
    let url = URLS.settings.savePassword;
    return this.request.patchApi(url, values);
  }


  setPassword(values): Observable<any> {
    let url = URLS.auth.setPassword;
    return this.request.patchApi(url, values);
  }


  savetwofa(values): Observable<any> {
    let url = URLS.settings.twofa;
    return this.request.patchApi(url, values);
  }

  savecommunication(values): Observable<any> {
    let url = URLS.settings.communication;
    return this.request.patchApi(url, values);
  }

  savePatientsX(values): Observable<any> {
    let url = URLS.auth.savePatientsx;
    return this.request.postApi(url, values);
  }

  saveProvidersX(values): Observable<any> {
    let url = URLS.auth.saveProvidersX;
    return this.request.postApi(url, values);
  }

  saveHospitalsX(values): Observable<any> {
    let url = URLS.auth.saveHospitalsX;
    return this.request.postApi(url, values);
  }

  getLoginUserInfos(): Observable<any> {
    let url = URLS.master.getLoginUserInfo;
    return this.request.getApi(url);
  }

   getAllUsers(): Observable<any> {
  // const url = this._baseUrl.concat(URLS.users.getUsersList);
  let url = URLS.master.getUsersLists;
    // alert(url)

  return this.request.getApi(url);
}


// ActivateUserAccounts
  editUserAccounts(id, values): Observable<any> {
    let url = URLS.account.editUserAccount;
    url = _.replace(url, "{id}", id);
    return this.request.putApi(url, values);
  }


  

  patchUserAccounts(id, values): Observable<any> {
    let url = URLS.account.editUserAccount;
    url = _.replace(url, "{id}", id);
    return this.request.patchApi(url, values);
  }



  ActivateUserAccounts(id): Observable<any> {
    let url = URLS.account.ActivateAccount;
    url = _.replace(url, "{id}", id);
    return this.request.getApi(url);
  }



  getContractList(event): Observable<any> {


    if (event.direction == 'desc') {
      event.direction = 2;
    }
    else {
      event.direction = 1;
    }

    let url = URLS.contract.getContractList + '?from=' + event.fromdate + '&to=' + event.todate + '&limit=' + event.pageSize + '&page=' + (event.pageIndex + 1) + '&searchkey=' + event.filterValue + '&order_by=' + event.active + '&dir=' + event.direction + '&type=' + event.type;
    return this.request.getApi(url);
  }

  saveContract(values): Observable<any> {
    let url = URLS.contract.saveContract;
    return this.request.postApi(url, values);
  }

  editContract(id, values): Observable<any> {
    let url = URLS.contract.editDeleteContract;
    url = _.replace(url, "{id}", id);
    return this.request.putApi(url, values);
  }

  deleteContract(data): Observable<any> {
    let url = URLS.contract.editDeleteContract;
    url = _.replace(url, "{id}", data.id);
    return this.request.deleteApi(url);
  }

  getContractInfo(id): Observable<any> {
    let url = URLS.contract.editDeleteContract
    url = _.replace(url, "{id}", id);
    return this.request.getApi(url);
  }

  getContractListAll(): Observable<any> {
    let url = URLS.contract.getContractFullList
    return this.request.getApi(url);
  }
}
